<template>
  <loginLayout>
    <div class="login-panl">
      <div class="step-warrp">
        <div class="step-header-warrp">
          <div
            :class="['step-item', { active: step >= item.id }]"
            v-for="item in stepList"
            :key="item.id"
          >
            <span>{{ item.id }}</span>
          </div>
        </div>
        <div class="step-content">
          <div
            :class="['step-item-text', { active: step >= item.id }]"
            v-for="item in stepList"
            :key="item.id"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 第一步 -->
      <div class="f-wrapper" v-if="step === 1">
        <Input
          class="login-input"
          placeholder="请输入手机号码"
          clearable
          v-model="form.name"
        >
          <template #prefix>
            <img
              class="login-name"
              src="../../assets/image/user-login-icon.png"
              alt=""
            />
          </template>
        </Input>
        <div class="flex-content-between login-pswd">
          <Input
            class="login-input"
            placeholder="请输入验证码"
            clearable
            v-model="form.code"
            style="width: 200px"
          >
            <template #prefix>
              <img
                class="login-name2"
                src="../../assets/image/user-login-icon3.png"
                alt=""
              />
            </template>
          </Input>
          <identify
            :identify-code="identifyCode"
            :content-height="60"
            @reloadEvent="reloadCodeEvent"
          />
        </div>
        <Button
          class="login-btn"
          type="primary"
          shape="circle"
          long
          :loading="loading1"
          @click="handleSubmit(1)"
          >下一步</Button
        >
      </div>
      <!-- 第二步 -->
      <div class="f-wrapper" v-if="step === 2">
        <div class="t-tips">为了你的帐号安全，请完成身份验证</div>
        <div class="t-tips" style="margin-top: 20px">
          手机号码：{{ account }}
        </div>
        <div class="flex-content-between login-pswd">
          <Input
            class="login-input"
            placeholder="请输入验证码"
            clearable
            v-model="form.code"
            @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
            style="width: 200px"
          >
            <template #prefix>
              <img
                class="login-name2"
                src="../../assets/image/user-login-icon3.png"
                alt=""
              />
            </template>
          </Input>
          <smsBtn
            ref="smsBtn"
            shape="circle"
            height="60px"
            @tap="getCodeEvent"
            style="width: 120px"
          ></smsBtn>
        </div>
        <Button
          class="login-btn"
          type="primary"
          shape="circle"
          long
          :loading="loading2"
          @click="handleSubmit(2)"
          >下一步</Button
        >
      </div>
      <!-- 第三步 -->
      <div class="f-wrapper" v-if="step === 3">
        <div class="t-tips">为了你的帐号安全，请完成身份验证</div>
        <div class="t-tips" style="margin-top: 20px">
          手机号码：{{ account }}
        </div>
        <div class="flex-content-between login-pswd">
          <Input
            class="login-input"
            type="password"
            placeholder="请输入新密码"
            clearable
            v-model="form.password"
          >
            <template #prefix>
              <img
                class="login-name2"
                src="../../assets/image/user-login-icon2.png"
                alt=""
              />
            </template>
          </Input>
        </div>
        <div class="flex-content-between login-pswd">
          <Input
            class="login-input"
            type="password"
            placeholder="请再次输入新密码"
            clearable
            v-model="form.confirmPassword"
          >
            <template #prefix>
              <img
                class="login-name2"
                src="../../assets/image/user-login-icon2.png"
                alt=""
              />
            </template>
          </Input>
        </div>
        <Button
          class="login-btn"
          type="primary"
          shape="circle"
          long
          :loading="loading3"
          @click="handleSubmit(3)"
          >下一步</Button
        >
      </div>
      <!-- 第四步 -->
      <div class="f-wrapper" v-if="step === 4">
        <div class="forgot-success">
          <img src="../../assets/image/user-success-icon.png" alt="" />
          <div class="t-tips" style="margin-top: 20px">
            恭喜你，密码重置成功！
          </div>
        </div>
        <Button
          class="login-btn"
          type="primary"
          shape="circle"
          long
          @click="toLogin"
          >立即登录</Button
        >
      </div>
    </div>
  </loginLayout>
</template>

<script>
import { makeCode } from "utils/identify";
import loginLayout from "./components/loginLayout.vue";
import identify from "components/identify.vue";
import smsBtn from "components/smsBtn.vue";
import { getEncrypt } from "utils/encrypt";
import {
  verifyCode,
  forgetPwdVerify,
  forgetPwdVerifySmsCode,
  forgetPwdChange,
} from "api/user.js";
export default {
  name: "sige",
  components: {
    loginLayout,
    identify,
    smsBtn,
  },
  data() {
    return {
      step: 1,
      stepList: [
        {
          id: 1,
          name: "输入验证码",
        },
        {
          id: 2,
          name: "校验信息",
        },
        {
          id: 3,
          name: "重置密码",
        },
        {
          id: 4,
          name: "完成",
        },
      ],
      identifyCode: "",
      agreement: false,
      form: {
        name: "",
        password: "",
        code: "",
        confirmPassword: "",
      },
      account: "",
      loading1: false,
      loading2: false,
      loading3: false,
    };
  },
  created() {
    this.identifyCode = makeCode();
  },
  methods: {
    reloadCodeEvent() {
      this.identifyCode = makeCode();
    },
    toLogin() {
      this.$router.replace({ name: "login" });
    },
    getCodeEvent(callback) {
      if (!/^1[0-9]{10}$/.test(this.form.name)) {
        this.$Message.warning("请输入正确的手机号码！");
        this.$refs.smsBtn.reset();
        return;
      }
      verifyCode(this.verifyCode)
        .then((res) => {
          if (res.code === 200 && res.result) {
            callback(true);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
    handleSubmit(step) {
      if (step === 1) {
        if (!this.form.name) {
          this.$Message.warning("请输入手机号！");
          return false;
        }
        if (!this.form.code) {
          this.$Message.warning("请输入验证码！");
          return false;
        }
        if (this.form.code.toLowerCase() !== this.identifyCode.toLowerCase()) {
          this.$Message.warning("请输入正确验证码！");
          return false;
        }

        this.loading1 = true;
        forgetPwdVerify({ account: this.form.name })
          .then((res) => {
            this.loading1 = false;
            this.form.code = "";
            if (res.code === 200 && res.result) {
              this.step = step + 1;
              this.verifyCode = res.data.verifyCode;
              this.account = res.data.phoneNumber;
              this.reloadCodeEvent();
              this.$nextTick(() => {
                this.$refs.smsBtn.getCodeEvent();
              });
            }
          })
          .catch(() => {
            this.loading1 = false;
            this.form.code = "";
            this.reloadCodeEvent();
          });
      } else if (step === 2) {
        if (!this.verifyCode) {
          this.$Message.warning("秘钥错误,请重新验证账户名称!");
          return false;
        }
        this.loading2 = true;
        forgetPwdVerifySmsCode({
          code: this.form.code,
          verifyCode: this.verifyCode,
        })
          .then((res) => {
            this.loading2 = false;
            const { code, data, result } = res;
            if (code === 200 && result) {
              this.step = step + 1;
              this.verifyCode = data;
              this.form.code = "";
            }
          })
          .catch(() => {
            this.loading2 = false;
            this.form.code = "";
          });
      } else if (step === 3) {
        this.loading3 = true;
        const params = {
          confirmPassword: getEncrypt(this.form.confirmPassword),
          newPassword: getEncrypt(this.form.password),
          verifyCode: this.verifyCode,
        };
        forgetPwdChange(params)
          .then((res) => {
            this.loading3 = false;
            const { code, result } = res;
            if (code === 200 && result) {
              this.step = step + 1;
            }
          })
          .catch(() => {
            this.loading3 = false;
          });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.login-panl {
  display: block;
  width: 506px;
  height: 615px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: 196px;
  transform: translateY(-50%);
  padding: 70px 50px 0;
  .step-warrp {
    .step-header-warrp {
      display: flex;
      .step-item {
        flex: 1;
        display: flex;
        align-items: center;
        &:first-child {
          &::before {
            border-top-left-radius: 6px;
            border-bottom-left-radius: 6px;
          }
        }
        &:last-child {
          &::after {
            border-top-right-radius: 6px;
            border-bottom-right-radius: 6px;
          }
        }
        span {
          display: inline-block;
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-radius: 50%;
          color: #333;
          font-size: 16px;
          font-weight: bold;
          background-color: #f4f7fe;
          border: 1px solid #b1b1b1;
        }
        &::before,
        &::after {
          content: "";
          flex: 1;
          height: 4px;
          background-color: #d6d6d6;
        }
      }
      .step-item.active {
        span {
          color: #fff;
          background-color: #2d8cf0;
          border: none;
        }
        &::before,
        &::after {
          background-color: #2d8cf0;
        }
      }
    }
    .step-content {
      display: flex;
      .step-item-text {
        flex: 1;
        text-align: center;
        margin-top: 20px;
        color: #333333;
        font-weight: bold;
      }
      .step-item-text.active {
        color: #2d8cf0;
      }
    }
  }
  .t-tips {
    font-size: 14px;
    font-weight: 400;
    color: #999;
  }
  .f-wrapper {
    margin-top: 20px;
    .login-name {
      margin-top: 22px;
    }
    .login-pswd {
      margin-top: 30px;
    }
    .login-name2 {
      margin-top: 18px;
    }
    .f-link {
      color: #999999;
    }
    .sms-check {
      cursor: pointer;
      color: #ff5c35;
      font-weight: 400;
    }
  }
  .forgot-success {
    padding: 40px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  /deep/.login-btn {
    margin-top: 40px;
    height: 60px;
    font-size: 14px;
    font-weight: 400;
  }
  /deep/.login-input {
    .ivu-input {
      height: 60px !important;
      line-height: 60px !important;
      border-radius: 40px;
      padding: 0 30px 0 50px !important;
      font-size: 16px;
      font-weight: 400;
      line-height: 60px;
    }
    .ivu-input-prefix {
      padding-left: 20px;
      width: auto;
      line-height: 60px;
    }
    .ivu-input-icon-clear {
      line-height: 60px;
      font-size: 24px;
    }
  }
}
</style>
